import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-grey-overlay',
    imports: [],
    templateUrl: './grey-overlay.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './grey-overlay.component.scss'
})
export class GreyOverlayComponent {

}
